module.exports = __webpack_public_path__ + "img/img_user_male.547e489a.png";